import { useId } from "react";
import { motion, useReducedMotion } from "framer-motion";

const V_MAIN =
  "M102 0 C 92 70 126 112 104 182 C 86 238 118 302 98 374 C 82 432 122 502 104 568 C 90 624 116 692 100 758 C 92 808 110 862 104 900";
const V_BRANCHES = [
  "M104 182 C 128 202 142 228 150 260",
  "M98 374 C 74 394 62 422 56 454",
  "M104 568 C 130 590 144 618 150 652",
];
const H_MAIN = "M0 60 C 120 46 240 76 360 58 C 480 42 600 72 720 56 C 800 46 860 64 900 56";

export const GoldSeam = ({ variant = "vertical", className = "", delay = 0.2, duration = 3 }) => {
  const reduce = useReducedMotion();
  const uid = useId().replace(/:/g, "");
  const isV = variant === "vertical";
  const gradId = `seamGrad-${uid}`;
  const glowId = `seamGlow-${uid}`;

  const draw = (d, extraDelay = 0, width = 1.4, opacity = 1) => (
    <motion.path
      key={d}
      d={d}
      fill="none"
      stroke={`url(#${gradId})`}
      strokeWidth={width}
      strokeLinecap="round"
      opacity={opacity}
      filter={`url(#${glowId})`}
      initial={{ pathLength: reduce ? 1 : 0 }}
      whileInView={{ pathLength: 1 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: reduce ? 0 : duration, delay: reduce ? 0 : delay + extraDelay, ease: "easeInOut" }}
    />
  );

  return (
    <svg
      viewBox={isV ? "0 0 200 900" : "0 0 900 120"}
      className={className}
      aria-hidden="true"
      preserveAspectRatio={isV ? "xMidYMin meet" : "none"}
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2={isV ? "0" : "1"} y2={isV ? "1" : "0"}>
          <stop offset="0%" stopColor="#D7BE8A" />
          <stop offset="50%" stopColor="#A9812F" />
          <stop offset="100%" stopColor="#7C5E22" />
        </linearGradient>
        <filter id={glowId} x="-60%" y="-60%" width="220%" height="220%">
          <feGaussianBlur stdDeviation="0.9" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      {isV ? (
        <>
          {draw(V_MAIN)}
          {V_BRANCHES.map((b, i) => draw(b, 0.5 + i * 0.35, 0.9, 0.75))}
        </>
      ) : (
        draw(H_MAIN, 0, 1.1)
      )}
    </svg>
  );
};

export default GoldSeam;
